import router from 'next/router';
import { EVENT_NAMES } from 'src/constants/common';
import { useItemClick } from 'src/hooks/useItemClick';
import { useSSRSelector } from 'src/redux';
import eventLogger from 'src/utils/eventLogger';
import { isPLPRequiredSystem } from 'src/utils/isPLPRequiredSystem';
import { getRoute, PATH } from 'src/utils/routes';

export default function useHandleClicks() {
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));

  const [onItemClick, getProductLink] = useItemClick();

  const generateLink = (type, data) => {
    switch (type) {
      case 'product': {
        return getProductLink(data);
      }
      case 'collection': {
        return getRoute(PATH.collectionCategories(data.id), storeData?.domain);
      }
      case 'category': {
        return getRoute(
          `${
            isPLPRequiredSystem(storeData?.theme?.theme_class) ? PATH.SHOP : PATH.PRODUCT
          }?cid=${data?.id || 0}`,
          storeData?.store_info?.domain
        );
      }
      default:
        return '';
    }
  };

  const onListItemClick = (type, data, e, openInNewTab) => {
    e.stopPropagation();
    switch (type) {
      case 'product': {
        onItemClick(data, e, openInNewTab);
        break;
      }
      case 'collection': {
        eventLogger(
          EVENT_NAMES.COLLECTION_WIDGET_CARD_CLICK,
          { collectionId: data.id },
          true
        );
        const link = getRoute(PATH.collectionCategories(data.id), storeData?.domain);
        !openInNewTab ? router.push(link)  : window.open(link, '_blank');
        break;
      }
      case 'category': {
        const redirectUrl = getRoute(
          `${
            isPLPRequiredSystem(storeData?.theme?.theme_class) ? PATH.SHOP : PATH.PRODUCT
          }?cid=${data?.id || 0}`,
          storeData?.store_info?.domain
        );
        if (openInNewTab) {
          window.open(redirectUrl, '_blank');
        } else {
          router.push(redirectUrl, undefined, { shallow: false });
        }
        break;
      }
    }
  };
  return { onListItemClick, generateLink };
}
